import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.filter.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoData from '@/components/NoData/NoData';
import SearchBoxNew from '@/components/Search/SearchBoxNew.vue';
import Sortable from 'sortablejs';
import remoteImg from '@/components/common/remoteImg';
import { setBaseurl } from '@/utils/auth';
import TaskContainer from '@/components/MessageAgentSub/TaskContainer';
export default {
  name: 'firstPage',
  data: function data() {
    var _JSON$parse, _JSON$parse$COMBINEDS;
    return {
      syslist: [],
      commonList: [],
      todoList: [],
      swiperOptions: {
        autoplay: {
          delay: 10000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        speed: 500,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
        // Some Swiper option/callback...
      },

      trendList: [],
      activeName: '综合搜索',
      checked: false,
      systemId: '',
      systemList: ((_JSON$parse = JSON.parse(sessionStorage.getItem('dist_info'))) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$COMBINEDS = _JSON$parse.COMBINEDSEARCH) === null || _JSON$parse$COMBINEDS === void 0 ? void 0 : _JSON$parse$COMBINEDS.LC_WEB) || [],
      total: 0,
      commonShow: false,
      funcName: '',
      resourceList: [],
      defaultProps: {
        children: 'children',
        label: 'resourceName'
      },
      selectResourceList: [],
      dashBoardShow: false,
      dashBoardList: [],
      allDashboard: [],
      menuList: [],
      swiperList: [],
      functionArr: [],
      showSwiperBtn: false,
      swiperLoading: false,
      loadingResource: true,
      systemInner: JSON.parse(sessionStorage.getItem('systemInner')),
      showFunction: false,
      systemBaseUrl: {},
      showDialog: false,
      todoTitle: '',
      dialogUrl: '',
      isShowCopyRight: process.env.VUE_APP_show_copyright
    };
  },
  methods: {
    getSvg: function getSvg() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var iconUrl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                iconUrl = '';
                return _context.abrupt("return", iconUrl);
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getSystem: function getSystem() {
      var _this2 = this;
      this.$API.getRequest({
        url: '/platform/systemInner/list',
        data: {
          pageNum: 1,
          pageSize: 10000
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          var systemInner = [];
          res.result.records.forEach(function (ele) {
            systemInner.push(ele.systemCategory[0]);
          });
          sessionStorage.setItem('systemInner', JSON.stringify(systemInner));
          _this2.systemInner = systemInner;
        }
      }).catch(function (err) {
        _this2.$message.warning(err.message);
      });
    },
    swiperEnter: function swiperEnter() {
      if (this.$refs.swiper && this.$refs.swiper.$swiper) {
        this.showSwiperBtn = true;
        this.$refs.swiper.$swiper.autoplay.stop();
      }
    },
    swiperLeave: function swiperLeave() {
      if (this.$refs.swiper && this.$refs.swiper.$swiper) {
        this.showSwiperBtn = false;
        this.$refs.swiper.$swiper.autoplay.start();
      }
    },
    toTask: function toTask(item) {
      if (item.urlType === 'NEW_PAGE') {
        window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(item.url)));
      } else if (item.urlType === 'DIALOG') {
        // 展示页面
        this.showDialog = true;
        this.dialogUrl = item.url;
        this.todoTitle = item.todoTitle;
      } else if (item.urlType === 'POPUP') {
        // 展示弹框
        this.$refs.TaskContainer.show(item);
      } else {
        this.$router.push({
          path: '/resource/messageAgent',
          query: {
            type: 'task',
            item: JSON.stringify(item)
          }
        });
        window.open(decodeURIComponent("".concat(window.location.origin, "/resource/messageAgent?newPage=").concat(item.url)));
      }
    },
    getDmResource: function getDmResource() {
      var _this3 = this;
      this.loadingResource = true;
      this.$API.getRequest({
        url: '/platform/resource/menuList',
        data: {
          pageNum: 1,
          pageSize: 100,
          systemId: 'LC_DM',
          resourceType: 'RESOURCE'
        }
      }).then(function (res) {
        _this3.loadingResource = false;
        if (res.code === '0000000000') {
          _this3.swiperList = [];
          _this3.menuList = res.result.records;
          _this3.dashBoardList.forEach(function (ele) {
            _this3.menuList.forEach(function (item) {
              if (item.resourceName === ele.dashboardResourceName && ele.selected) {
                _this3.swiperList.push({
                  url: item.baseUrl + item.path
                });
              }
            });
          });
        }
      });
    },
    openedMethod: function openedMethod() {
      var _this = this;
      var el = document.getElementById('items');
      var s = new Sortable(el, {
        animation: 150,
        ghostClass: 'blue-background-class',
        dataIdAttr: 'data-no',
        onEnd: function onEnd() {
          var arr = s.toArray();
          _this.functionArr = arr;
        }
      });
    },
    clearSelect: function clearSelect() {
      this.selectResourceList = [];
    },
    toRegularTrends: function toRegularTrends() {
      var url = '';
      this.systemInner.forEach(function (ele) {
        if (ele.systemId === 'LC_REGULATORY_TRENDS') {
          url = ele.baseUrl;
        }
      });
      window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(url, "&menuPath=/?&isHash=1")));
    },
    toRegulatory: function toRegulatory(id) {
      var url = '';
      this.systemInner.forEach(function (ele) {
        if (ele.systemId === 'LC_REGULATORY_TRENDS') {
          url = ele.baseUrl;
        }
      });
      window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(url, "&menuPath=/detailPage?detailId=").concat(id, "&isHash=1")));
    },
    openIframe: function openIframe(item) {
      // let url = item.path.replace('http://172.19.218.187:9533/#/', 'http://localhost:8080/#/')
      // if(item.resourceName === '首页'){
      //   url = null
      // }
      this.$API.postRequest({
        url: '/platform/app/click/log',
        data: {
          resourceId: item.id,
          url: item.path,
          urlRef: ''
        }
      });
      var url = item.path.split('.com');
      if (item.systemId === 'LC_OA') {
        history.pushState('a', '', "".concat(window.location.origin, "/dashboard"));
      } else {
        if (url[1]) {
          history.pushState('a', '', "".concat(window.location.origin, "/#").concat(url[1]));
        } else {
          history.pushState('a', '', window.location.origin);
        }
      }

      // window.location.herf = window.location.origin
      // let basecontenturl = url[0];
      sessionStorage.setItem('defaultactivemenu', item.resourceId);
      this.$store.dispatch('settings/changeSetting', {
        key: 'breadcrumb',
        value: item
      });
      this.$store.dispatch('settings/changeSetting', {
        key: 'menuactivehome',
        value: false
      });
      var title = document.getElementsByTagName('title')[0];
      title.innerText = "\u667A\u80FD\u5408\u89C4\u5E73\u53F0";
      var resourcePath = JSON.stringify(item);
      sessionStorage.setItem('resourcePath', resourcePath);
      if (item.systemId === 'LC_PLATFORM') {
        // sessionStorage.removeItem('loadPath')
        this.$store.dispatch('settings/changeSetting', {
          key: 'iframeUrl',
          value: null
        });
        this.$router.push(url[1]);
      } else {
        this.$store.dispatch('settings/changeSetting', {
          key: 'iframeUrl',
          value: item.path
        });
      }
    },
    delComFunc: function delComFunc(data) {
      this.selectResourceList = this.selectResourceList.filter(function (ele) {
        return ele.resourceId !== data.resourceId;
      });
    },
    submitDashBoard: function submitDashBoard() {
      var _this4 = this;
      var data = [];
      this.dashBoardList.forEach(function (element) {
        if (element.selected) {
          data.push(element.dashboardId);
        }
      });
      this.$API.postRequest({
        url: '/platform/dashboard/saveSelectedDashboard',
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this4.$message({
            message: '设定成功',
            type: 'success'
          });
          _this4.dashBoardShow = false;
          _this4.getAllDashboard();
        }
      });
    },
    dashBoardCancel: function dashBoardCancel() {
      this.dashBoardShow = false;
    },
    /**
     * @description:
     * @return {*}
     */
    getAllDashboard: function getAllDashboard() {
      var _this5 = this;
      this.$API.getRequest({
        url: '/platform/dashboard/getAllDashboard'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.dashBoardList = res.result;
          _this5.getDmResource();
        }
      });
    },
    showComFunc: function showComFunc() {
      this.commonShow = true;
    },
    cancelClick: function cancelClick() {
      this.commonShow = false;
      this.getSelect();
    },
    getTask: function getTask() {
      window.open(decodeURIComponent("".concat(window.location.origin, "/resource/messageAgent?type=task")));
    },
    searchTitle: function searchTitle(systemId, value, url, path, isHash) {
      var flag = false;
      if (this.systemId === '') {
        flag = true;
        // eslint-disable-next-line guard-for-in
        for (var key in this.systemList) {
          this.systemId = key;
          break;
        }
        if (value !== '') {
          this.$API.postRequest({
            url: '/platform/superSearch/saveHistory',
            data: {
              keyWord: value
            }
          });
        }
      }
      if (flag) {
        this.$router.push({
          path: '/combinedSearch',
          query: {
            systemId: this.systemId,
            keyWord: value,
            isPrecise: this.$refs.searchBoxNew.isPrecise ? 1 : 0
          }
        });
      } else {
        window.open("".concat(window.location.origin, "/?newPage=").concat(url, "&isHash=0&menuPath=").concat(window.encodeURIComponent(path)));
      }
    },
    getToDoList: function getToDoList() {
      var _this6 = this;
      this.$API.postRequest({
        url: 'platform/todo/user',
        data: {
          pageNum: 1,
          pageSize: 5,
          param: {
            todoStates: ['PENDING']
          }
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this6.todoList = res.result.list;
          _this6.total = res.result.total;
        }
      });
    },
    getTrends: function getTrends() {
      var _this7 = this;
      this.$API.postRequest({
        url: '/rt/regulatoryTrends/pagingQuery',
        data: {
          pageNum: '1',
          pageSize: '4'
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this7.trendList = res.result;
        }
      });
    },
    setSystem: function setSystem(name) {
      this.$refs.searchBoxNew.showHistory = false;
      if (name === '') {
        this.activeName = '综合搜索';
        this.systemId = '';
      } else {
        this.activeName = this.systemList[name];
        this.systemId = name;
      }
    },
    /**
     * @description: 重用功能查询
     * @return {*}
     */
    getCommonSearch: function getCommonSearch() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this8.$API.getRequest({
                  url: '/platform/app/suggest'
                }).then(function (res) {
                  if (res.code === '0000000000') {
                    //   res.result.forEach(async ele => {

                    //     await this.$API.getRequest({
                    //             url: `/platform/file/downLoadPicture/${ele.functionIcon}`,
                    //                 }).then( data => {
                    //                     if(data.code == 200){
                    //                         ele.functionIcon =  'data:image/svg+xml;base64,'+ data.result
                    //                     }
                    //                 })
                    //     that.commonList.push(ele)

                    // })
                    _this8.commonList = res.result;
                  }
                });
              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    /**
     * @description: 提交重用功能
     * @return {*}
     */
    submitCom: function submitCom() {
      var _this9 = this;
      var data = [];
      this.selectResourceList.forEach(function (ele) {
        data.push({
          id: ele.id
        });
      });
      if (this.functionArr.length > 9) {
        this.$message.warning('常用功能');
        return;
      }
      if (this.functionArr.length > 0) {
        data = [];
        this.functionArr.forEach(function (ele) {
          data.push({
            id: ele
          });
        });
      }
      this.$API.postRequest({
        url: '/platform/app/save',
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this9.$message({
            message: '更改成功',
            type: 'success'
          });
          _this9.commonShow = false;
          _this9.getCommonSearch();
        }
      });
    },
    /**
     * @description: 获取常用功能选择列表
     * @return {*}
     */
    getResource: function getResource() {
      var _this10 = this;
      this.$API.getRequest({
        url: '/platform/app/search'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this10.resourceList = res.result;
        }
      });
    },
    /**
     * @description: 已选常用功能列表
     * @return {*}
     */
    getSelect: function getSelect() {
      var _this11 = this;
      this.selectResourceList = [];
      this.$API.getRequest({
        url: '/platform/app/customized'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this11.selectResourceList = res.result;
        }
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      if (data.path === null) {
        return;
      }
      var list = [];
      if (this.selectResourceList.length > 9) {
        this.$message({
          message: '您当前选择的常用功能个数已达上限（9）！',
          type: 'warning'
        });
        return;
      }
      list = this.selectResourceList.filter(function (ele) {
        return ele.resourceId === data.resourceId;
      });
      if (list.length === 0) {
        this.selectResourceList.push(data);
      }
    },
    /**
     * @description: 查询常用功能
     * @return {*}
     */
    searchForm: function searchForm() {
      var _this12 = this;
      this.$API.getRequest({
        url: '/platform/app/search',
        data: {
          resourceName: this.funcName
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this12.resourceList = res.result;
        }
      });
    },
    handleMessage: function handleMessage(e) {
      var data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
      if (data.type === 'CLOSEMODAL') {
        this.showDialog = false;
        this.searchForm();
      }
      if (data.type === 'MSGSUCCESS') {
        this.$message({
          message: '回复评论成功！',
          type: 'success'
        });
        this.showDialog = false;
        this.searchForm();
      }
      if (data.type === 'APPROVESUCCESS') {
        this.$message({
          message: '审核成功！',
          type: 'success'
        });
        this.showDialog = false;
        this.searchForm();
      }
      if (data.type === 'APPROVEERROR') {
        this.$message({
          message: '审核失败！',
          type: 'warning'
        });
        this.showDialog = false;
        this.searchForm();
      }
      if (data.type === 'ERROR') {
        this.$message({
          message: '回复评论失败！',
          type: 'success'
        });
        this.showDialog = false;
        this.searchForm();
      }
    }
  },
  created: function created() {
    var _this13 = this;
    // this.getMenuList();
    this.getSystem();
    this.getToDoList();
    this.getTrends();
    this.getCommonSearch();
    this.getResource();
    this.getSelect();
    this.getAllDashboard();
    this.isPrecise = this.$route.query.isPrecise === '1';
    this.$API.getRequest({
      url: '/platform/component/detailInfo',
      data: {
        systemType: 'PC_WEB'
      }
    }).then(function (res) {
      if (res.code === '0000000000') {
        res.result.forEach(function (ele) {
          _this13.systemBaseUrl[ele.systemId] = ele.baseUrl;
        });
      }
      setBaseurl(JSON.stringify(_this13.systemBaseUrl));
    });
    window.addEventListener('message', this.handleMessage);
  },
  destroyed: function destroyed() {
    window.removeEventListener('message', this.handleMessage);
  },
  mounted: function mounted() {
    // this.$refs.swiper.$swiper;

    this.syslist = [];
  },
  watch: {
    swiperList: {
      handler: function handler(N) {
        if (N.length > 1) {
          this.swiper && this.swiper.autoplay.start();
        } else {
          this.swiper && this.swiper.autoplay.stop();
        }
      }
    }
  },
  computed: {
    swiper: function swiper() {
      var _this$$refs$swiper;
      return (_this$$refs$swiper = this.$refs.swiper) === null || _this$$refs$swiper === void 0 ? void 0 : _this$$refs$swiper.$swiper;
    }
  },
  components: {
    SearchBoxNew: SearchBoxNew,
    NoData: NoData,
    remoteImg: remoteImg,
    TaskContainer: TaskContainer
  }
};